import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import DigitizeImg from "../../../images/location_new/fold5/game-digi.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Digitize(props) {
  return (
    <div
      className="digitize_sec p-100"
      style={{
        background: "linear-gradient(180deg, #604293 0%, #8D42AF 100%)",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              The Ultimate Mobile Game Development Company in UK to Elevate Your
              Business
            </h2>
            <p>
              TekRevol’s commitment to excellence makes it the ultimate choice
              to elevate your business through cutting-edge mobile game
              development in UK. As the top mobile game developers in UK, we
              bring a wealth of expertise to craft immersive and engaging gaming
              experiences that resonate with your audience.
            </p>
            <p>
              At TekRevol, we believe in the power of immersive gaming
              experiences to drive business success. Join forces with us, and
              let our tailored mobile game development solutions become the
              catalyst for your business's growth.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="mobile-game-development-company-in-london"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
